import { useSelector } from "react-redux";
import { ReduxStoreState } from "web/redux/store";

export function useAvailableFilters(): string[] {
    return useSelector(
        (state: ReduxStoreState) => state.filters.data?.filters.map((filter) => filter.id) ?? []
    );
}
